import { DeleteEntityDialog } from "@/components/common/delete-entity-dialog";
import { useDeleteProductBrand } from "@/hooks/products/use-product-brands";
import type { ProductBrand } from "@/types/products/api-types/product-brand-types";

interface DeleteBrandDialogProps {
  brand: ProductBrand | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteBrandDialog({
  brand,
  open,
  onOpenChange,
}: DeleteBrandDialogProps) {
  const deleteBrand = useDeleteProductBrand();

  return (
    <DeleteEntityDialog
      entity={brand}
      open={open}
      onOpenChange={onOpenChange}
      entityName="Brand"
      onDelete={async (id) => {
        await deleteBrand.mutateAsync(id);
      }}
      isDeleting={deleteBrand.isPending}
      conflictMessage={`Cannot delete brand "${brand?.name}" because it has associated products`}
    />
  );
}
